import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import { setToken } from '@/utils/auth';
import { getToken } from '@/api/user/user';

export default {
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, code, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _this.$route.query || '', code = _ref.code;

              if (!code) {
                _context.next = 14;
                break;
              }

              _context.prev = 2;
              _context.next = 5;
              return getToken({ code: code });

            case 5:
              res = _context.sent;


              if (Number(_.get(res, 'data.code')) === 0) {
                setToken(res.data.data.token);
                _this.$router.push({ path: '/' });
              } else {
                _this.promopt(res.msg);
              }
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](2);

              _this.promopt();

            case 12:
              _context.next = 15;
              break;

            case 14:
              _this.promopt();

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 9]]);
    }))();
  },


  methods: {
    promopt: function promopt(msg) {
      var _this2 = this;

      this.$alert(msg || '登录失败，请重新尝试登陆', '提示', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          _this2.$store.dispatch('LogOut');
        }
      });
    }
  }
};